module.exports = __webpack_public_path__ + "img/DrySystem_Overview-DS_4.8ad4843b.jpg";